export default "__VITE_ASSET__Bllp3YxK__"